'use client';

import { useState, createContext, useContext, ReactNode } from 'react';
import { IOS } from '@/constants';

type QrPopupContextType = {
  qrPopup: boolean;
  socialType: string;
  closeQrPopup: () => void;
  openQrPopup: (type: string) => void;
};

const QrPopupContext = createContext<QrPopupContextType | undefined>(undefined);

export const QrPopup = (props: { children: ReactNode }) => {
  const [qrPopup, setQrPopup] = useState(false);
  const [socialType, setSocialType] = useState<string>(IOS);

  const closeQrPopup = () => {
    setQrPopup((prev) => !prev);
  };

  const openQrPopup = (type: string) => {
    setSocialType(type);
    setQrPopup(true);
  };

  return (
    <QrPopupContext.Provider
      value={{
        qrPopup,
        socialType,
        closeQrPopup,
        openQrPopup,
      }}>
      {props.children}
    </QrPopupContext.Provider>
  );
};

const useQrPopupContext = () => {
  const ctx = useContext(QrPopupContext);
  if (!ctx) {
    throw new Error('useQrPopupContext must be used within QrPopup provider');
  }
  return ctx;
};

export default useQrPopupContext;


